require('@wix/new-relic-angular-client/dist/nr-ng-client.js');
require('ts-global-module-loader!@wix/wix-bi-logger/angular.js');
require('ts-global-module-loader!@wix/wix-bi-adapter/dist/scripts/WixBIAdapter.js');
require('ts-global-module-loader!@wix/wix-graphql-query-builder/dist/src/GraphQlQuery.js');
